export const propertiesData = [
    {
      value: "Everything is A-OK LLC - 229 Victory Drive Norman, OK 73072",
      label: "Everything is A-OK LLC - 229 Victory Drive Norman, OK 73072",
      units: [
        {
          value: "test1",
          label: "test1",
        },
      ],
    },
    {
      value: "A New Creation L.L.C. - 11711 Lorene Ave  Midwest City, OK 73130",
      label: "A New Creation L.L.C. - 11711 Lorene Ave  Midwest City, OK 73130",
      units: [
        {
          value: "test2-1",
          label: "test2-1",
        },
        {
          value: "test2-2",
          label: "test2-2",
        },
        {
          value: "test2-3",
          label: "test2-3",
        },
      ],
    },
    {
      value: "AT&T - PO Box 5014  Carol Stream, IL 60197",
      label: "AT&T - PO Box 5014  Carol Stream, IL 60197",
      units: [],
    },
  ];
  export const GLAccountsData = [
      {
          label:'Expense',
          options: [
              {
                label: 'Commissions/Placement Fees',
                value: 'Commissions/Placement Fees',
              },
              {
                label: 'Lease Renewal Fee',
                value: 'Lease Renewal Fee',
              },
              {
                label: 'Rental Tax Authority',
                value: 'Rental Tax Authority',
              },
              {
                label: 'Vendor Discounts',
                value: 'Vendor Discounts',
              },
            ],
          label:'Capital',
          options: [
              {
                label: 'Appfolio Opening Balance Equity',
                value: 'Appfolio Opening Balance Equity',
              },
              {
                label: '109: Retained Earnings',
                value: '109: Retained Earnings',
              },
              {
                label: '110: Owner Contribution',
                value: '110: Owner Contribution',
              },
              {
                label: '111: Owner Draw',
                value: '111: Owner Draw',
              },
            ],
      }
  ]